import { PropsWithChildren } from 'react';

interface ChatContextMenuItemProps {
  onClick?: () => void;
}

export const ChatContextMenuItem = ({
  children,
  onClick,
}: PropsWithChildren<ChatContextMenuItemProps>) => (
  <button
    type="button"
    onMouseDown={(event) => event.preventDefault()}
    onClick={onClick}
    className="flex items-center px-2 py-1.5 text-sm text-foreground hover:bg-muted hover:rounded-md cursor-pointer w-full"
    data-testid="chat-context-menu-item"
    data-chat-context-menu-item
  >
    <span className="truncate">{children}</span>
  </button>
);
